module.exports = __webpack_public_path__ + "img/lr_12.3d8a898f.png";